import { PDFViewer, pdf } from '@react-pdf/renderer'
import { useState } from 'react'
import { VoucherType } from 'types/types'

import { SingleVoucher } from './VoucherPDF'

// Mock data pro testování
const mockVoucher: VoucherType = {
  id: 1,
  code: 'TEST-VOUCHER-123',
  voucher_name: 'Jan Novák',
  lesson_type_name: 'Základní lekce',
  valid_until: '2025-12-31',
  created_date: '2025-01-15',
  lesson_type_code: 'basic',
  merchant_id: 1,
  order_id: 1,
  price: 2000,
  redeemed_date: null,
  status: 'active',
}

export const VoucherTest = () => {
  const [testResult, setTestResult] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)
  const [base64Size, setBase64Size] = useState<number>(0)

  const testPDFConversion = async () => {
    setIsLoading(true)
    setTestResult('Začínám konverzi...')

    try {
      // Krok 1: Vytvoření PDF blob
      setTestResult('Krok 1/3: Vytvářím PDF blob...')
      const blob = await pdf(<SingleVoucher voucher={mockVoucher} />).toBlob()
      setTestResult(
        `Krok 1/3: ✓ PDF blob vytvořen (${(blob.size / 1024).toFixed(2)} KB)`,
      )

      // Krok 2: Převod na base64
      setTestResult(
        `Krok 2/3: Převádím blob na base64... (${(blob.size / 1024).toFixed(2)} KB)`,
      )
      const reader = new FileReader()

      const base64data: string | ArrayBuffer | null = await new Promise(
        (resolve, reject) => {
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        },
      )

      if (typeof base64data === 'string') {
        const base64Length = base64data.length
        setBase64Size(base64Length)
        setTestResult(
          `Krok 2/3: ✓ Base64 vytvořen (${(base64Length / 1024).toFixed(2)} KB)\n` +
            `Krok 3/3: ✓ ÚSPĚCH - PDF lze převést na base64!\n\n` +
            `Blob velikost: ${(blob.size / 1024).toFixed(2)} KB\n` +
            `Base64 velikost: ${(base64Length / 1024).toFixed(2)} KB\n` +
            `Náhled base64: ${base64data.substring(0, 100)}...`,
        )
      } else {
        throw new Error('Base64 data nejsou string')
      }
    } catch (error) {
      setTestResult(`❌ CHYBA: ${error instanceof Error ? error.message : 'Neznámá chyba'}`)
      console.error('PDF conversion error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex' }}>
      {/* Levá strana - PDF Preview */}
      <div style={{ width: '70%', height: '100%' }}>
        <PDFViewer width="100%" height="100%">
          <SingleVoucher voucher={mockVoucher} />
        </PDFViewer>
      </div>

      {/* Pravá strana - Test Controls */}
      <div
        style={{
          width: '30%',
          padding: '20px',
          backgroundColor: '#1a1a1a',
          color: 'white',
          overflowY: 'auto',
        }}
      >
        <h2 style={{ marginBottom: '20px' }}>Test PDF Konverze</h2>

        <button
          onClick={testPDFConversion}
          disabled={isLoading}
          style={{
            padding: '10px 20px',
            backgroundColor: isLoading ? '#666' : '#ffea00',
            color: 'black',
            border: 'none',
            borderRadius: '4px',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '20px',
            width: '100%',
          }}
        >
          {isLoading ? 'Testuji...' : 'Test PDF → Blob → Base64'}
        </button>

        {testResult && (
          <div
            style={{
              backgroundColor: '#2a2a2a',
              padding: '15px',
              borderRadius: '4px',
              whiteSpace: 'pre-wrap',
              fontFamily: 'monospace',
              fontSize: '12px',
              lineHeight: '1.5',
            }}
          >
            {testResult}
          </div>
        )}

        {base64Size > 0 && (
          <div style={{ marginTop: '20px', fontSize: '14px' }}>
            <p>
              <strong>Info:</strong> PDF se úspěšně převedlo. Toto je stejný
              proces, který se používá v <code>sendPDFs()</code> na řádku 36 v
              utils.tsx.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
